import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"doge"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 22C17.5228 22 22 17.7862 22 12.5882V2H18.1111L16.4444 4.15479C15.1056 3.52858 13.5965 3.17647 12 3.17647C10.4035 3.17647 8.8944 3.52858 7.55556 4.15479L5.33333 2H2V12.5882C2 17.7862 6.47715 22 12 22Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12.001 13.5C11.501 14.5 10.751 15 10.001 15.0625C10.3343 16.0417 11.201 18 12.001 18C12.801 18 13.6676 16.0417 14.001 15.0625C13.251 15 12.501 14.5 12.001 13.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 12V2H18.1111L16.6528 3.88544M2 12V2H5.33333L7.27778 3.88544M22 12.5882C22 17.7862 17.5228 22 12 22C6.47715 22 2 17.7862 2 12.5882C2 7.39026 6.47715 3.17647 12 3.17647C17.5228 3.17647 22 7.39026 22 12.5882Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 10V11M16 10V11M15.3143 14.7043C14.2568 15.4235 12.8053 15.1088 12.0009 13.5C11.1965 15.1088 9.74503 15.4235 8.6875 14.7043M13.9164 15.3C13.5369 16.3265 12.7404 18 12.0009 18C11.2613 18 10.4648 16.3265 10.0853 15.3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Doge = Vue.extend<IconProps>({
  name: 'DogeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'doge',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Doge;
